(() => {
  const TEST_ID = "MMI21";
  const VARIANT_ID = "V1";

  function logInfo(message) {
    console.log(
      `%cAcadia%c${TEST_ID}-${VARIANT_ID}`,
      "color: white; background: rgb(0, 0, 57); font-weight: 700; padding: 2px 4px; border-radius: 2px;",
      "margin-left: 8px; color: white; background: rgb(0, 57, 57); font-weight: 700; padding: 2px 4px; border-radius: 2px;",
      message,
    );
  }

  logInfo("fired");

  const SELECTORS = Object.freeze({
    BODY: "body",
    EXPERIMENT_BODY_CLASS: "MMI21",
    PRODUCT_ATC_BTN: ".main-product-v2__atc-button",
    CART_BTN: ".m-cart-style-custom",
  });

  function addBodyClass(className) {
    if (document.body && !document.body.classList.contains(className)) {
      document.body.classList.add(className);
    }
  }

  function waitForElem(
    waitFor,
    callback,
    minElements = 1,
    isVariable = false,
    timer = 10000,
    frequency = 25,
  ) {
    let elements = isVariable
      ? window[waitFor]
      : document.querySelectorAll(waitFor);

    if (timer <= 0) return;

    (!isVariable && elements.length >= minElements) ||
    (isVariable && typeof window[waitFor] !== "undefined")
      ? callback(elements)
      : setTimeout(
          () =>
            waitForElem(
              waitFor,
              callback,
              minElements,
              isVariable,
              timer - frequency,
            ),
          frequency,
        );
  }

  function triggerInitialCartOpen() {
    const start = Date.now();
    const timeoutMs = 8000;

    const wait = setInterval(() => {
      const api = window.NSHybridCart;
      const hasApi = api && typeof api.open === "function";
      const hasElement = !!document.querySelector("ns-hybrid-cart");

      if (hasApi && hasElement) {
        clearInterval(wait);
        try {
          api.open();
        } catch (e) {
          // Don't brick the page if the cart isn't fully hydrated yet.
          // A second try, without clobbering internal state, is safe.
          setTimeout(() => {
            try {
              api.open();
            } catch (_) {}
          }, 250);
        } finally {
          window.nsHybridUpdated = true;
        }
      }

      if (Date.now() - start > timeoutMs) {
        clearInterval(wait);
      }
    }, 50);
  }

  function addToCartWithoutRedirect(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const form = event.target.closest("form");
    if (!form) return;

    const formData = new FormData(form);

    const variantId = formData.get("id");

    const sellingPlan = formData.get("selling_plan");

    const quantity = formData.get("quantity") || 1;

    let url = `/cart/add.js?items[0][id]=${variantId}&items[0][quantity]=${quantity}`;

    if (sellingPlan) {
      url += `&items[0][selling_plan]=${sellingPlan}`;
    }

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        items: [
          {
            id: parseInt(variantId),
            quantity: parseInt(quantity),
            ...(sellingPlan && { selling_plan: parseInt(sellingPlan) }),
          },
        ],
      }),
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        document.dispatchEvent(new CustomEvent("cart:update"));
        triggerInitialCartOpen();
      })
      .catch((error) => console.error("Error:", error));

    return false;
  }

  function mainJs() {
    addBodyClass(SELECTORS.EXPERIMENT_BODY_CLASS);

    const addToCartBtn = document.querySelector(SELECTORS.PRODUCT_ATC_BTN);

    if (addToCartBtn) {
      addToCartBtn.addEventListener("click", addToCartWithoutRedirect, true);
    }
  }

  waitForElem(SELECTORS.PRODUCT_ATC_BTN, mainJs, 1, false, 15000);
})();
